import {
  PageBlueprint,
  createFrontendPlugin,
} from '@backstage/frontend-plugin-api';
import { convertLegacyRouteRef } from '@backstage/core-compat-api';
import { rootRouteRef } from './routes';

const capabilitiesPage = PageBlueprint.make({
  params: {
    path: '/capabilities',
    routeRef: convertLegacyRouteRef(rootRouteRef),
    title: 'Capabilities',
    loader: () =>
      import('./components/CapabilitiesComponent').then(m => (
        <m.CapabilitiesComponent />
      )),
  },
});

/**
 * @public
 */
export default createFrontendPlugin({
  pluginId: 'capabilities',
  extensions: [capabilitiesPage],
  routes: {
    root: convertLegacyRouteRef(rootRouteRef),
  },
});
